"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LockedPageBanner = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var classnames_1 = __importDefault(require("classnames"));
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var c = (0, BemBuilder_1.default)("project-info-banner");
var LockedPageBanner = function (_a) {
    var _b;
    var status = _a.status, auditTrail = _a.auditTrail, auditTrailHandler = _a.auditTrailHandler;
    return (react_1.default.createElement("section", { className: (0, classnames_1.default)(c(), (_b = {}, _b["".concat(c("", "center"))] = !auditTrail, _b)) },
        react_1.default.createElement("div", { className: c("locked-page-text") },
            react_1.default.createElement(icons_1.Security, { className: c("locked-page-icon"), size: icons_1.IconSize.Small }),
            react_1.default.createElement("div", { className: "title" }, "".concat(status, " pages are locked to edits")),
            react_1.default.createElement(kaleidoscope_1.Link, { href: "https://help.qwilr.com/article/749-new-sharing-security-settings-summer-2022", className: c("locked-page-link"), theme: kaleidoscope_2.LinkTheme.Dark }, "Learn more")),
        auditTrail && (react_1.default.createElement(kaleidoscope_1.Button, { size: kaleidoscope_1.ButtonSize.Small, type: kaleidoscope_1.ButtonType.Secondary, onClick: auditTrailHandler }, "Audit trail"))));
};
exports.LockedPageBanner = LockedPageBanner;
